import React from 'react'

import { Popup, ProgressBar } from 'devextreme-react'

const ProgressDialog = (props) => {

    const handleCancel = (e) => {
        props.onCancel(props.id)
    }

    const statusFormat = (ratio, value) => {
        return `Progress: ${Math.round(ratio * 100)}% (${value}/${props.data.total})`;
    }

    return (
        <Popup
            visible={true}
            position='left bottom'
            showTitle={true}
            showCloseButton={true}
            shading={false}
            title={props.title}
            width='320px'
            height='auto'
            hideOnOutsideClick={false}
            onHiding={handleCancel}
        >
            <ProgressBar
                width='300px'
                statusFormat={statusFormat}
                max={props.data.total}
                min={0}
                value={props.data.count === -1 ? false : props.data.count}
                onComplete={handleCancel}
            />
        </Popup>
    )
}

export default ProgressDialog
